import { defineMessages } from 'react-intl';

export default defineMessages({
	sceneVolume: {
		id: 'app.components.SceneVolumeControl.BackgroundVolume2',
		defaultMessage: 'Scene Volume',
		description: 'A title for a volume slider to change the volume of a scene video background',
	},
});
